import { blossom, branch, bud, drift, petal } from '../motifs';
import { M, PAPER } from '../palette';
import { registerPlate } from '../registry';

const SAKURA = ['#ffe0ea', '#f498b4', '#c85a7c'] as const;

/** 09 บุปผา: the blossom plate, warm paper heaped with pink cherry blossom. */
registerPlate({
  id: 'blossom',
  name: 'บุปผา',
  ground: PAPER,
  trim: M.maroon,
  text: { fill: [M.maroon, M.ink], line: M.whiteHi },
  inset: [15, 12],
  front(p, f) {
    branch(
      p,
      [
        [f.x - 5, f.b - 1],
        [f.x + 4, f.y + 6],
        [f.x + 14, f.y - 4],
      ],
      1.8,
      0.6,
    );
    branch(
      p,
      [
        [f.r + 5, f.y - 2],
        [f.r - 4, f.y + 2],
        [f.r - 10, f.y - 3],
      ],
      1.4,
      0.6,
    );
    for (const [x, y, r] of [
      [f.x - 2, f.y + 4, 4.2],
      [f.x + 4, f.y - 1, 4.7],
      [f.x + 10, f.y - 5, 3.9],
      [f.x - 3, f.b - 3, 3.9],
      [f.x + 6, f.b - 1, 3.4],
      [f.x + 15, f.y - 6, 2.9],
      [f.r - 4, f.y - 1, 4.4],
      [f.r + 2, f.y + 6, 3.9],
      [f.r - 9, f.y - 3, 3.1],
      [f.r - 1, f.b - 2, 3.6],
    ] as const)
      blossom(p, x, y, r, SAKURA, M.goldHi);
    bud(p, f.x + 14, f.y - 2, SAKURA);
    bud(p, f.r + 4, f.y - 3, SAKURA);
  },
  motion: {
    sprites: { petal: { w: 2, h: 2, draw: (p) => petal(p, 0, 0, SAKURA) } },
    play(a, t, f) {
      drift(a, 'petal', t, 3, f.x - 4, 18, f.y - 4, f.b + 10, { speed: 0.28, slant: 6 });
      drift(a, 'petal', t, 2, f.r - 10, 12, f.y - 2, f.b + 9, { speed: 0.24, seed: 3 });
    },
  },
});
